var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ul',[_c('li',[_c('router-link',{attrs:{"to":_vm.link}},[_vm._v(_vm._s(_vm.artist.full_name)+" "+_vm._s(_vm.artist.last_name))]),_vm._v(" "),_c('div',{staticClass:"deactivate_btn"},[_c('a',{staticClass:"pri_btn d_btn",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm._toggle.apply(null, arguments)}}},[_vm._v("Edit")])])],1)])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-100c94c0","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/artists/Artist.vue
// module id = hK9a
// module chunks = 1